import { AnyAction } from 'redux'
import { TEMPLATE_PURPOSES_UPDATE, SORTING_STRATEGY_UPDATE, QUICK_VIEW_ID_RESET, SET_VIEW_ID, SET_IS_SIMILAR_PRODUCT } from '~/app/store/debug/actions'
import { CONTENT_UPDATE, LOCATION_POP } from '~/app/store/constants'
import { TEMPLATE_PURPOSES } from '~/shared/constants'

const initialState: State.DebugState = {
  debug: false,
  bypassApproval: false,
  lastRequestUrl: undefined,
  noCache: false,
  forcedRankingStrategyOverride: '',
  useConstraints: true,
  renderPropsOverride: {} as State.RenderPropsState,
  quickViewId: '',
  isDirectQuickView: false,
  experienceType: '',
  templatePurposes: [],
  sortingStrategy: null,
  searchBackend: null,
  source: null,
  designCreationTypes: [],
  aspExperimentFlags: null,
  isSimilarProduct: false,
  takeOverQV: false,
  selectedDesignId: '',
  showSets: false,
  rawSets: null,
  forwardedPath: '',
  urlId: '',
}

export function reducer(state: State.DebugState = initialState, action: AnyAction): State.DebugState {
  switch (action.type) {
    case SET_VIEW_ID:
      return {
        ...state,
        quickViewId: action.payload.designId,
      }
    case QUICK_VIEW_ID_RESET:
      return {
        ...state,
        quickViewId: '',
        isDirectQuickView: false,
      }
    case SET_IS_SIMILAR_PRODUCT:
      return {
        ...state,
        isSimilarProduct: action.payload.isSimilarProduct,
      }
    case CONTENT_UPDATE:
      return {
        ...state,
        lastRequestUrl: action.payload.requestUrl,
      }
    case TEMPLATE_PURPOSES_UPDATE:
    case LOCATION_POP:
      return {
        ...state,
        templatePurposes: action.payload.templatePurposes,
        quickViewId: action.payload.query.qv,
        showSets: action.payload.showSets,
        rawSets: action.payload.rawSets,
      }
    case SORTING_STRATEGY_UPDATE:
      return {
        ...state,
        sortingStrategy: action.payload.sortingStrategy,
        forcedRankingStrategyOverride: action.payload.forcedRankingStrategyOverride,
      }
    default:
      return state
  }
}

export const getBypassApproval = (state: State.GlobalState): Gallery.Models.Url.ValidParsedQsValue<boolean> => state.debug.bypassApproval

export const getDebugModeEnabled = (state: State.GlobalState): boolean => !!state.debug.debug

export const getNoCache = (state: State.GlobalState): Gallery.Models.Url.ValidParsedQsValue<boolean> => state.debug.noCache

export const getUseConstraints = (state: State.GlobalState): Gallery.Models.Url.ValidParsedQsValue<boolean> => state.debug.useConstraints

export const getRenderPropsOverrides = (state: State.GlobalState): State.RenderPropsState => state.debug.renderPropsOverride

export const getForcedRankingStrategyOverride = (state: State.GlobalState): Gallery.Models.Url.ValidParsedQsValue<string> =>
  state.debug.forcedRankingStrategyOverride

export const getQuickViewId = (state: State.GlobalState): Gallery.Models.Url.ValidParsedQsValue<string> => state.debug.quickViewId

export const getIsDirectQuickView = (state: State.GlobalState): boolean => state.debug.isDirectQuickView

export const getExperienceType = (state: State.GlobalState): Gallery.Models.Url.ValidParsedQsValue<string> => state.debug.experienceType

export const getTemplatePurposes = (state: State.GlobalState): TEMPLATE_PURPOSES[] => state.debug.templatePurposes

export const getSearchBackend = (state: State.GlobalState): Gallery.Models.Url.ValidParsedQsValue<string> => state.debug.searchBackend

export const getDesignCreationTypes = (state: State.GlobalState): Gallery.Models.Url.ValidParsedQsValue<string[]> => state.debug.designCreationTypes

export const getASPExperimentFlags = (state: State.GlobalState): Gallery.Models.Url.ASPExperimentFlags => state.debug.aspExperimentFlags

export const getSimilarProduct = (state: State.GlobalState): Gallery.Models.Url.ValidParsedQsValue<boolean> => state.debug.isSimilarProduct

export const getTakeOverQV = (state: State.GlobalState): Gallery.Models.Url.ValidParsedQsValue<boolean> => state.debug.takeOverQV

export const getSelectedDesignId = (state: State.GlobalState): Gallery.Models.Url.ValidParsedQsValue<string> => state.debug.selectedDesignId

export const getShowSets = (state: State.GlobalState): Gallery.Models.Url.ValidParsedQsValue<boolean> => state.debug.showSets

export const getRawSets = (state: State.GlobalState): Gallery.Models.Url.ValidParsedQsValue<Gallery.Models.Url.JSONObject[]> => state.debug.rawSets

export const getForwardedPath = (state: State.GlobalState): string => state.debug.forwardedPath

export const getUrlId = (state: State.GlobalState): string => state.debug.urlId
